import React, {PropTypes} from 'react';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import OpenPipPrograms from '@deere/cps-it.warranty-model-factory/lib/open-pip-programs';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getOpenPipsColumnDefinitions} from '../report-services/column-definitions';

function onColumnRemoved(columnEvent) {

    this.hideReportColumn(columnEvent);

}

function handleGridApiDefinition(params) {

    this.onCreateAgGridApi(params);

}

const ReportContainer = props => {

    const gridOptions = {
        dateComponentFramework: WarrantyAgGridDatePicker
    };

    return (
        <div>
            <NumberOfRecordsFound count={props.report.length}/>
            <section className='report'>
                {props.reportVariant.isReportColumnsVisible && <ReportHiddenColumns/>}
                <ReportHeader
                    columnApi={props.columnApi}
                    gridApi={props.gridApi}
                    reportName='open-pip-programs'
                >
                </ReportHeader>
                <ReportGrid
                    columnDefs={getOpenPipsColumnDefinitions()}
                    gridOptions={gridOptions}
                    localeText={getAgGridLocaleText()}
                    onColumnVisible={props::onColumnRemoved}
                    onGridReady={props::handleGridApiDefinition}
                    rowData={props.report}
                />
            </section>
        </div>
    );

};

ReportContainer.displayName = 'ReportContainer';
ReportContainer.propTypes = {
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    hideReportColumn: PropTypes.func.isRequired,
    onCreateAgGridApi: PropTypes.func.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(OpenPipPrograms)).isRequired,
    reportVariant: PropTypes.object.isRequired
};

export default ReportContainer;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/components/open-pip-programs-report-container.js